import { fetchTextOk } from './http'

export function makeViewApi() {
  async function view(mint, page = 1) {
    const m = String(mint || '').trim()

    let url = '/api/view'
    const p = Number(page)
    if (Number.isFinite(p) && p > 0) {
      const qs = new URLSearchParams()
      qs.set('page', String(p))
      url += `?${qs.toString()}`
    }

    await fetchTextOk(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mint: m }),
    })
  }

  return { view }
}
